export default {
  BACKGROUND_COLOR_HEADER: 'rgba(45, 45, 45, 0.98)',
  BACKGROUND_COLOR_HEADER0: '#FFF',

  HEADER_MENU: '#FFF',
};
